import { Modal } from '@repo/ui';
import type { Children } from '@repo/shared/types';

import type { LoanModalProcessUnion } from '../store/loan-process.store';
import { LOAN_PROCESS_STATE } from '../store/loan-process.store';

interface LoanProcessModalProps extends Children {
  loanProcessState?: LoanModalProcessUnion;
}

export function LoanProcessModalComponent({ loanProcessState, children }: LoanProcessModalProps) {
  return (
    <Modal
      fullScreen={loanProcessState === LOAN_PROCESS_STATE.AGREEMENT_LIBERIS_IFRAME}
      isOpen
      maxWidth={loanProcessState === LOAN_PROCESS_STATE.AGREEMENT_AND_APPROVALS ? 'lg' : 'xs'}
    >
      {children}
    </Modal>
  );
}
